import { SearchChatsData } from "@sms/shared/chat/search/search.interface";
import { all, call, Effect, put, take, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "typesafe-actions";

import { socketChats } from "../chat.sockets";
import entryActionsChat from "../chat.entry-actions";

import {
  searchChatAction,
  updateSearchResultsDataAction,
  setIsLoadingSearchAction,
  updateSearchResultsDataToDefaultEmptyAction
} from "./search.actions";

// const channelSearch: any = (query: string): any =>
//   eventChannel(emit => {
//     socketChats.emit("search", query, (data: SearchChatsData) => emit(searchResultsChatAction(data)));
//     return (): void => {};
//   });

function fetchSearchData(query: string): Promise<SearchChatsData> {
  return new Promise((resolve, reject) => {
    socketChats.emit("search", query, (data: SearchChatsData) => {
      if (data) {
        resolve(data);
      } else {
        reject(new Error(`Failed to fetch search with data ${query}`));
      }
    });
  });
}

function* search(query: string | null): Generator<Effect | Generator, void, SearchChatsData> {
  try {
    yield put(updateSearchResultsDataToDefaultEmptyAction());

    // yield delay(250);
    if (query && query !== "") {
      yield put(setIsLoadingSearchAction(true));

      const searchResult: SearchChatsData = yield call(fetchSearchData, query);

      yield put(updateSearchResultsDataAction(searchResult));

      yield put(setIsLoadingSearchAction(false));
    }
  } catch (error) {
    console.error(error);
  } finally {
    yield put(setIsLoadingSearchAction(false));
  }
}

export function* searchWatchers(): Generator<Effect | Generator, void> {
  while (true) {
    yield take(entryActionsChat.handleConnectSocketChat);

    yield all([takeLatest(searchChatAction, ({ payload }: PayloadAction<string, string | null>) => search(payload))]);
  }
}
